import React from "react";
import { copyright } from "./copyright.module.scss";

const Copyright = () => (
  <div className={copyright}>{"© All rights reserved."}</div>
);

export default Copyright;
